import { BasicButton, Stack } from "@certn/cascadia";
import { FormLabelRAC } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { justReturnControl, schemaIsNullable } from "./utils";

/** This wrapper adds an interface for nullable fields (where the key is optional in the
 * data) This is only present if the form `isCheckResults` and is not `readonly` or
 * `hidden`.
 *
 * If the type for the field in the schema includes "null" then elements will be
 * rendered:
 * - If the value is null: an "Add" button below the label
 * - If the value is not null: the control to be rendered and a "Set to null" button
 * which sets the value to `null` in the form values
 */
export function CheckResultsNullableWrapper(props: Props) {
  const {
    children,
    schema,
    isCheckResults,
    readonly,
    hidden,
    data,
    setValue,
    label,
  } = props;
  const { t } = useTranslation(); // FIXME: I assume this shit don't work
  const [showField, setShowField] = useState(data !== null);

  const isNullable = useMemo(() => schemaIsNullable(schema), [schema]);

  const handleAddValue = () => {
    setShowField(true);
  };

  const handleClearValue = () => {
    setValue(null);
    setShowField(false);
  };

  if (justReturnControl(readonly, hidden, isCheckResults, isNullable)) {
    return <>{children}</>;
  }

  if (!showField && data === null) {
    return (
      <Stack gap="space-1">
        {label && <FormLabelRAC>{label}</FormLabelRAC>}
        <BasicButton onPress={handleAddValue}>{t("Add")}</BasicButton>
      </Stack>
    );
  }

  return (
    <Stack orientation="horizontal">
      <div className={styles.fieldWrapper}>{children}</div>
      <BasicButton onPress={handleClearValue}>{t("Set to null")}</BasicButton>
    </Stack>
  );
}

const styles = {
  fieldWrapper: css({ flexGrow: 1 }),
};
